import Cookies from 'js-cookie';

/* eslint-disable no-undef */
class FBCoversionsApi {
	constructor(data = {}) {
		this.data = {
			...data,
			test: true,
		};
		this.checkoutPage = window.location.href.includes('/checkouts/');
		this.thankYouPage = window.location.href.includes('/orders/');
		this.locatorPage = window.location.href.includes('/pages/find-your-smartsweets')
			|| window.location.href.includes('/pages/storelocator');

		this.init();
	}

	init() {
		this.event('PageView');
		if (this.checkoutPage) {
			this.event('Initiate Checkout');
		}
		if (this.thankYouPage) {
			this.event('Purchase');
		}
		if (this.locatorPage) {
			this.event('LocatorSearch');
		}

		//Listen to add to cart, change cart, if added send Add
		addEventListener('cart.requestComplete', (e, cart) => {
			let countDiff = cart.item_count - this.data.num_items;
			let priceDiff = cart.items_subtotal_price - this.data.price;

			if (countDiff > 0 || priceDiff > 0) {
				this.event('Add to Cart', {
					num_items: countDiff,
					price: priceDiff,
				});
			}

			//Update totals for dynamic purposes
			this.data.num_items = cart.item_count;
			this.data.price = cart.items_subtotal_price;
		});
	}

	event(type = 'Purchase', customData = {}) {
		const data = this.eventStructure(type, customData);
		//TODO: Just a note that I removed the insecure token and replaced it with the default tracking info
		// FB.api(`/${this.data.pixelId}/events?access_token=${this.data.token}`, 'POST', data, (r) => {
		//   }
		// );
		if (typeof fbq === 'function') {
			fbq('track', type, data);
		}


		//TikTok Extension
		if (typeof ttq !== 'undefined') {
			if (type == 'PageView') {
				ttq.track('ViewContent')
			}
			else if (type == 'Add to Cart') {
				ttq.track('AddToCart')
			}
			else if (type == 'Purchase') {
				ttq.track('PlaceAnOrder')
			}
		}
	}

	eventStructure(type = 'Purchase', customData) {
		let time = new Date();
		time = Math.floor(time.getTime() / 1000); //Round to 10 digits
		let json = { data: [] };

		const userData = {
			em: this.data.email,
			fn: this.data.first_name,
			ln: this.data.last_name,

			//New, requested
			fb_login_id: typeof FB !== 'undefined' && FB?.getUserID(),
			fbp: window.Cookiebot?.consented && Cookies.get('_fbp'),
			// db: Object.values(
			//   CF?.customer.get([
			//     "birthday_year",
			//     "birthday_month",
			//     "birthday_day",
			//   ])
			// )
			//   ?.filter((i) => i && i != "")
			//   .join(""),
			// ge: [ "{{ 'f/m' | sha256 }}" ]
		};
		const defaultData = {
			// "event_id": 12345,
			"event_name": type,
			"event_time": time,
			"action_source": "email",
			"user_data": userData,
			"event_source_url": window.location.href,
		};
		const priceData = {
			"currency": this.currency,
			"value": this.data.price / 100,
		};

		if (type == 'PageView') {
			json = {
				"data": [
					{
						...defaultData,
						// "user_data": userData,
					}
				]
			};
		}
		else if (type == 'LocatorSearch') {
			json = {
				"data": [
					{
						...defaultData,
						"user_data": userData,
						// "custom_data": priceData,
					}
				]
			};
		}
		else if (type == 'Add to Cart') {
			json = {
				data: [
					{
						...defaultData,
						"user_data": userData,
						"custom_data": {
							...priceData,
							"value": customData.price,
							"num_items": customData.num_items, //this.data.num_items,
						}
					}
				],
			}
		}
		else if (type == 'Initiate Checkout') {
			json = {
				data: [
					{
						...defaultData,
						"user_data": userData,
						"custom_data": {
							...priceData,
							"num_items": this.data.num_items,
						}
					}
				],
			}
		}
		else if (type == 'Purchase') {
			json = {
				data: [
					{
						...defaultData,
						"user_data": userData,
						"custom_data": priceData,
					}
				],
			}
		}

		if (this.data.testCode) {
			json.test_event_code = this.data.testCode;
		}

		json.data = JSON.stringify(json.data);
		return json;
	}
}

export default FBCoversionsApi;
